module.exports = __webpack_public_path__ + "static/img/company-logo-1.26465fb8.png";